import { observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SearchChargesRequest {
  /**
   * Number of records to be selected.
   * @example
   * 20
   */
  @observable
  limit?: number;

  /**
   * Number of records to be skipped before selecting records.
   * @example
   * 1
   */
  @observable
  offset?: number;

  /**
   * Vehicle registration plate or null.
   * @example
   * 1A13456
   */
  @observable
  licensePlate?: string;

  /**
   * Official record ID or null.
   * @example
   * ABC-23456/2022
   */
  @observable
  officialRecordId?: string;

  /**
   * Charge email or null.
   */
  @observable
  emailAddress?: string;

  /**
   * Phone number.
   */
  @observable
  notificationPhoneNumber?: string;

  /**
   * Order identifier (variable symbol) or null.
   */
  @observable
  orderIdent?: number;

  /**
   * Payment bank account number or null.
   */
  @observable
  bankAccountNumber?: string;

  /**
   * Payment bank account bank code.
   */
  @observable
  bankCode?: string;

  /**
   * Card number.
   */
  @observable
  cardNumber?: string;

  /**
   * Country ID.
   * @example
   * 389f9475-192f-476f-9d6e-62934311801b
   */
  @observable
  countryId?: string;

  /**
   * Charge ID.
   */
  @observable
  chargeId?: string;

  /**
   * Charge order ID.
   */
  @observable
  chargeOrderId?: string;
}

const customMessage = "oneOfAttributesIsRequired";

const requiredWithoutCountryIfCondition = (entity: SearchChargesRequest) =>
  !entity.officialRecordId &&
  !entity.licensePlate &&
  !entity.orderIdent &&
  !entity.bankAccountNumber &&
  !entity.chargeOrderId &&
  !entity.emailAddress &&
  !entity.notificationPhoneNumber &&
  !entity.cardNumber &&
  !entity.chargeId;

const requiredCountryIfCondition = (entity: SearchChargesRequest) =>
  entity.countryId &&
  !entity.licensePlate &&
  !entity.orderIdent &&
  !entity.chargeOrderId &&
  !entity.chargeId &&
  !entity.officialRecordId;

export const SearchChargesRequestValidationRules: EntityValidationRules<SearchChargesRequest> = {
  licensePlate: {
    requiredIf: {
      condition: (entity: SearchChargesRequest) => {
        return entity.countryId ? !!requiredCountryIfCondition(entity) : !!requiredWithoutCountryIfCondition(entity);
      },
      customMessage: customMessage,
    },
    isLicensePlate: {
      required: false,
    },
  },
  officialRecordId: {
    requiredIf: {
      condition: (entity: SearchChargesRequest) => {
        return entity.countryId ? !!requiredCountryIfCondition(entity) : !!requiredWithoutCountryIfCondition(entity);
      },
      customMessage: customMessage,
    },
    isLength: {
      min: 3,
      max: 50,
      optional: true,
    },
  },
  orderIdent: {
    range: { min: 1000000001, max: 9999999999, optional: true },
    requiredIf: {
      condition: (entity: SearchChargesRequest) => {
        return entity.countryId ? !!requiredCountryIfCondition(entity) : !!requiredWithoutCountryIfCondition(entity);
      },
      customMessage: customMessage,
    },
  },
  emailAddress: {
    isLength: {
      min: 3,
      optional: true,
    },
    requiredIf: {
      condition: (entity: SearchChargesRequest) => {
        return entity.countryId ? false : !!requiredWithoutCountryIfCondition(entity);
      },
      customMessage: customMessage,
    },
  },
  notificationPhoneNumber: {
    isSimplePhoneNumber: {
      required: false,
    },
    requiredIf: {
      condition: (entity: SearchChargesRequest) => {
        return entity.countryId ? false : !!requiredWithoutCountryIfCondition(entity);
      },
      customMessage: customMessage,
    },
  },
  bankAccountNumber: {
    isLength: {
      min: 3,
      max: 35,
      optional: true,
    },
    requiredIf: {
      condition: (entity: SearchChargesRequest) => {
        return entity.countryId ? false : !!requiredWithoutCountryIfCondition(entity);
      },
      customMessage: customMessage,
    },
  },
  bankCode: {
    isLength: {
      min: 3,
      max: 11,
      optional: true,
    },
  },
  chargeOrderId: {
    isLength: {
      min: 36,
      max: 36,
      optional: true,
    },
    requiredIf: {
      condition: (entity: SearchChargesRequest) => {
        return entity.countryId ? !!requiredCountryIfCondition(entity) : !!requiredWithoutCountryIfCondition(entity);
      },
      customMessage: customMessage,
    },
  },
  cardNumber: {
    isLength: {
      min: 3,
      max: 24,
      optional: true,
    },
    requiredIf: {
      condition: (entity: SearchChargesRequest) => {
        return entity.countryId ? false : !!requiredWithoutCountryIfCondition(entity);
      },
      customMessage: customMessage,
    },
  },
  chargeId: {
    isLength: {
      min: 36,
      max: 36,
      optional: true,
    },
    requiredIf: {
      condition: (entity: SearchChargesRequest) => {
        return entity.countryId ? !!requiredCountryIfCondition(entity) : !!requiredWithoutCountryIfCondition(entity);
      },
      customMessage: customMessage,
    },
  },
};
